var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHalstack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 139.667,
    height: 139.686,
    viewBox: "0 0 139.667 139.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.489,
    y2: 0.961,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d008f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad4eff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-157.198 -243.269)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.865 313.749) rotate(135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0H8.3a28,28,0,0,1,28,28V99.673H36a36,36,0,0,1-36-36V4A4,4,0,0,1,4,0Z",
    transform: "translate(0 0)",
    fill: "#80f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.198 312.544) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.931,0H8.844A27.516,27.516,0,0,1,36.36,27.516V99.576A36.36,36.36,0,0,1,0,63.216V3.931A3.931,3.931,0,0,1,3.931,0Z",
    transform: "translate(0 0)",
    fill: "url(#a)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalstack);
export default __webpack_public_path__ + "static/media/halstack.8d8ba61f3c46e80fb5477e3d7eb7ee96.svg";
export { ForwardRef as ReactComponent };